var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"w-100",staticStyle:{"background-color":"#f4f4f4"}},[_c('b-row',{staticClass:"justify-content-center w-100",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12","sm":"8","md":"6","lg":"4","xl":"4"}},[_c('div',{staticClass:"bg-white",staticStyle:{"min-height":"100vh"}},[_c('router-view')],1)])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec56656","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 